import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FileItem } from 'ng2-file-upload';

@Component({
    selector: 'ca-file-upload-progress',
    templateUrl: './file-upload-progress.component.html',
    styleUrls: ['./file-upload-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadProgressComponent {
    @Input() file: FileItem;
    @Input() set uploadProgress(progress: number) {
        this.progressChanged.emit(progress);
    }
    @Output() cancelFileUpload = new EventEmitter<FileItem>();
    @Output() progressChanged = new EventEmitter<number>();
}
